import React, { FC, memo, useCallback } from 'react'

import { Container, InputContainer, Order, TextContainer } from './sort-item-styles'
import SortOptionTransport from '../../../../transports/common/sort-option-transport'
import { useTranslation } from '../../../../hooks/locale'

interface Props {
    onSortSubmit: (link: string) => void
    sortItem: SortOptionTransport
    getDisplayLabel?: (label: string) => string
}

const DEFAULT_ORDER = 'default'

const SortItem: FC<Props> = ({ onSortSubmit, sortItem }) => {
    const { t } = useTranslation()
    const handleSortItemClick = useCallback(() => {
        if (!sortItem.isActive) {
            onSortSubmit(sortItem.url)
        }
    }, [onSortSubmit, sortItem.isActive, sortItem.url])

    const order = sortItem.order ?? DEFAULT_ORDER

    return (
        <Container>
            <InputContainer
                type="radio"
                name="sortRadioButton"
                onChange={handleSortItemClick}
                checked={sortItem.isActive ?? false}
            />
            <TextContainer>
                <span>{t(sortItem.label)}</span>
                {order !== DEFAULT_ORDER && <Order>({t(order)})</Order>}
            </TextContainer>
        </Container>
    )
}

export default memo(SortItem)
